import { render, staticRenderFns } from "./FastExchangePrice.vue?vue&type=template&id=64e73d66&scoped=true&"
import script from "./FastExchangePrice.vue?vue&type=script&lang=js&"
export * from "./FastExchangePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e73d66",
  null
  
)

export default component.exports